<!-- Container avec effet de remontée -->
<div class="relative z-10 -mt-20 mb-4 rounded-lg bg-white">
  <!-- Section titre avec badge -->
  <div class="px-2 py-6 md:px-6">
    <div class="flex items-start justify-between">
      <div>
        <!-- Titre et badge -->
        <div class="mb-4 flex items-center gap-3">
          <h1 class="text-3xl font-bold text-greyscale-900">
            {{ trip.title || ("impactReport.tripHeader.trip" | transloco) }}
          </h1>
          <!-- Commented as long as contribution is not implemented -->
          <!-- <span
            class="rounded-full bg-warning-100 px-3 py-1 text-sm font-medium text-warning-700"
          >
            @if (hasContributed) {
              {{ "impactReport.tripHeader.contributed" | transloco }}
            } @else {
              {{ "impactReport.tripHeader.notContributed" | transloco }}
            }
          </span> -->
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center gap-3">
        <app-pdf
          [tripId]="trip.id"
          [title]="trip.title"
          [logoSources]="logoSources"
        />
      </div>
    </div>

    <!-- 3. Informations du voyage -->
    <div
      class="flex flex-col gap-4 text-sm text-greyscale-600 lg:flex-row lg:items-center lg:justify-between"
    >
      <!-- Informations du voyage -->
      <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-8">
        <div class="flex items-center gap-2">
          <lucide-angular [img]="calendarIcon" class="h-4 w-4"></lucide-angular>
          <span
            >{{ "impactReport.tripHeader.tripDuration" | transloco }} :
            <strong class="text-greyscale-900"
              >{{ trip.days || 0 }}
              {{
                (trip.days || 0) > 1
                  ? ("impactReport.tripHeader.days" | transloco)
                  : ("impactReport.tripHeader.day" | transloco)
              }}</strong
            ></span
          >
        </div>

        <div class="flex items-center gap-2">
          <lucide-angular [img]="usersIcon" class="h-4 w-4"></lucide-angular>
          <span
            >{{ "impactReport.tripHeader.travelers" | transloco }} :
            <strong class="text-greyscale-900"
              >{{ trip.travellers || 0 }}
              {{
                (trip.travellers || 0) > 1
                  ? ("impactReport.tripHeader.people" | transloco)
                  : ("impactReport.tripHeader.person" | transloco)
              }}</strong
            ></span
          >
        </div>

        <div class="flex items-center gap-2">
          <lucide-angular [img]="globeIcon" class="h-4 w-4"></lucide-angular>
          <span
            >{{ "impactReport.tripHeader.countries" | transloco }} :
            <strong class="text-greyscale-900">{{
              getCountriesText()
            }}</strong></span
          >
        </div>

        @if (clients.length > 0) {
          <div class="flex items-center gap-2">
            <lucide-angular [img]="usersIcon" class="h-4 w-4"></lucide-angular>
            <span
              >{{ "impactReport.tripHeader.clients" | transloco }} :
              <strong class="text-greyscale-900">{{
                getClientsText()
              }}</strong></span
            >
          </div>
        }
        <div class="flex flex-row items-center gap-1">
          <i class="pi pi-calendar text-gray-400"></i>
          <span class="text-paragraph-s-med text-gray-400"
            >{{ "calculator.lastUpdate" | transloco }} :</span
          >
          <span class="text-paragraph-s-med text-gray-900"
            >{{ trip.updatedAt | date: "dd/MM/yyyy" }}
          </span>
        </div>

        @if (hasBrochures) {
          <div class="flex items-center gap-2">
            <lucide-angular [img]="fileTextIcon" class="h-4 w-4"></lucide-angular>
            <span>
              {{ (brochures.length > 1 ? "dashboard.brochures" : "dashboard.brochure") | transloco }} :
              @for (doc of brochures; track doc.id; let isLast = $last) {
                <!-- TODO GRE-414: restore download when S3 URL bug is fixed
                <button
                  (click)="brochureDownloadService.downloadBrochure(doc.s3Url, doc.originalFileName)"
                  class="cursor-pointer font-medium text-primary-600 transition-colors hover:text-primary-700 hover:underline"
                  [pTooltip]="getBrochureTooltip(doc.originalFileName)"
                  tooltipPosition="bottom"
                >
                  {{ brochureDownloadService.truncateFilename(doc.originalFileName) }}
                </button>
                -->
                <span
                  class="font-medium text-greyscale-900"
                  [pTooltip]="doc.originalFileName"
                  tooltipPosition="bottom"
                >
                  {{ brochureDownloadService.truncateFilename(doc.originalFileName) }}</span>@if (!isLast) {<span>, </span>}
              }
            </span>
          </div>
        }
      </div>

      <!-- Lien méthodologie aligné à droite -->
      @if (!packLimitationService.isDiscovery()) {
        <button
          type="button"
          (click)="methodologyService.download()"
          [disabled]="methodologyService.loading()"
          class="flex items-center gap-1.5 text-sm text-primary-600 transition-colors hover:text-primary-700 disabled:opacity-60"
          [pTooltip]="'impact.methodology.tooltip' | transloco"
          tooltipPosition="top"
        >
          <lucide-angular [img]="bookIcon" class="h-4 w-4"></lucide-angular>
          <span>{{ "impact.methodology.link" | transloco }}</span>
        </button>
      }
    </div>
  </div>
</div>
